module.exports = __webpack_public_path__ + "static/media/moons_cuanto_cuestan-960.6b0aa314.jpg";